// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__12_9o","content":"LayoutSettings_content__2q4Zi"};